import React, { Component, createRef } from 'react';
import { IInputProps } from '../../../models/components/input-text';
import Translator from '../../../core/i18n';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { Guid } from 'guid-typescript';
import { string } from 'prop-types';
const T = Translator.create();

export class InputFormik extends React.Component<IInputProps> {
    public validateDiv: HTMLDivElement | null = null;

    public state = {
        validateBarGuid: '',
        isOtherColorActive: false
    };

    constructor(props: any) {
        super(props);
        this.state.validateBarGuid = Guid.create().toString();
    }

    public onValid() {
        if (this.props.touched && this.props.errors && this.validateDiv) {
            this.validateDiv.innerText = this.props.errors;
            this.validateDiv.classList.remove('success');
            this.validateDiv.classList.add('error');
            const getValidateElement = document.getElementById(this.state.validateBarGuid);
            if (getValidateElement) {
                getValidateElement.style.backgroundColor = '#FF6F61';
                getValidateElement.style.width = '100%';
                this.state.isOtherColorActive = true;
            }
        } else if (this.props.touched && !this.props.errors && this.validateDiv) {
            this.validateDiv.innerText = '';
            this.validateDiv.classList.remove('error');
            this.validateDiv.classList.add('success');
            const getValidateElement = document.getElementById(this.state.validateBarGuid);
            if (getValidateElement) {
                getValidateElement.style.backgroundColor = '#39B27B';
                getValidateElement.style.width = '100%';
                this.state.isOtherColorActive = true;
            }
        } else {
            if (this.validateDiv) {
                this.validateDiv.innerText = '';
            }
        }
    }

    public render() {
        this.onValid();
        return (
            <div className="form-input form-group">
                <input
                    type={this.props.type}
                    name={this.props.name}
                    onChange={this.props.handleChange}
                    onBlur={this.props.handleBlur}
                    value={this.props.value}
                    required={false}
                    style={{ borderBottom: this.state.isOtherColorActive ? '0' : '' }}
                />
                <span className="highlight" />
                <div className="row" style={{ justifyContent: 'center', margin: 0 }}>
                    <span className="bar-form" id={this.state.validateBarGuid} />
                </div>
                <label>{this.props.placeHolder ? this.props.placeHolder : ''}</label>
                <div style={{ position: 'absolute' }} ref={e => (this.validateDiv = e)} className="" />
            </div>
        );
    }
}

export default InputFormik;
